export enum CallStatus {
  CONNECTING = 'CONNECTING',
  MISSED = 'MISSED',
  BUSY = 'BUSY',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  FAILED = 'FAILED',
}
